(function () {
  ('use strict');

  // Get the value of the data-wg-translated attribute
  const htmlElement = document.documentElement;
  const translatedLang = htmlElement.getAttribute('data-wg-translated') || 'en';

  // Get text values from translationMaps based on attribute values
  const copyLinkText = (window.translationMaps.CopyLink && window.translationMaps.CopyLink[translatedLang]) || 'Copy Link';
  const copiedText = (window.translationMaps.Copied && window.translationMaps.Copied[translatedLang]) || 'Copied';

  // Copy current url
  const buttons = document.querySelectorAll('.button-copy');
  if (!buttons.length) return;
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      navigator.clipboard
        .writeText(window.location.href)
        .then(function () {
          button.textContent = copiedText;
          setTimeout(function () {
            button.textContent = copyLinkText;
          }, 1500);
        })
        .catch(function (error) {
          console.error('Failed to copy URL: ', error);
        });
    });
  });
})();
